import moment from "jalali-moment";

export function formatDate(date, format = "YYYY/MM/DD") {
  if (date === "" || date === null) return;
  return moment(date, "YYYY/MM/DD").locale("fa").format(format);
}
